import { useState } from "react";
import { Modal } from "../../components/ui/modal";
import { useToast } from "../../components/ui/toast";
import { useRenameAgent } from "./queries";
import type { Agent } from "./types";

export function RenameAgentModal({ agent, onClose }: { agent: Agent; onClose: () => void }) {
  const agentName = agent.agent_name || agent.name || "Untitled Agent";
  const [name, setName] = useState(agentName);
  const rename = useRenameAgent();
  const toast = useToast();

  const unchanged = name.trim() === agentName;
  const empty = name.trim() === "";

  const onRename = () => {
    rename.mutate(
      { id: agent.agent_id, name: name.trim() },
      {
        onSuccess: () => { toast.success("Agent renamed", name.trim()); onClose(); },
        onError: (e) => toast.danger("Rename failed", (e as Error).message),
      }
    );
  };

  return (
    <Modal
      title="Rename Agent"
      subtitle={`Rename "${agentName}" to:`}
      onClose={onClose}
      width="max-w-sm"
      footer={
        <>
          <button onClick={onClose} className="rounded-lg border border-line px-4 py-2 text-sm font-semibold text-ink hover:bg-soft">
            Cancel
          </button>
          <button
            onClick={onRename}
            disabled={unchanged || empty || rename.isPending}
            className="rounded-lg bg-ink px-4 py-2 text-sm font-semibold text-canvas hover:opacity-90 disabled:cursor-not-allowed disabled:opacity-40"
          >
            {rename.isPending ? "Renaming…" : "Rename"}
          </button>
        </>
      }
    >
      <input
        type="text"
        value={name}
        onChange={(e) => setName(e.target.value)}
        maxLength={50}
        autoFocus
        className="w-full rounded-md border border-line bg-soft px-3 py-2 text-sm text-ink outline-none focus:border-brand"
        placeholder="Enter new agent name"
      />
    </Modal>
  );
}
